
































import Vue from 'vue';
import FollowUpSummary from './FollowUpSummary.vue';
import _ from 'lodash';
import FollowUp from './FollowUp.vue';
import { FollowUp as FollowUpType } from '@/store/types';
export default Vue.extend({
    components: { FollowUp, FollowUpSummary },
    props: {
        followUps: {
            type: Array as () => FollowUpType[],
            required: true,
        },
    },
    computed: {
        selectedFollowUpId(): number {
            return _.parseInt(_.last(_.split(this.$route.hash, '#')) || '');
        },
    },
    methods: {
        isSelectedFollowUp(followUp: FollowUpType): boolean {
            if (+followUp.id === this.selectedFollowUpId) {
                return true;
            }
            if (!this.$route.hash || this.$route.hash === '#') {
                // If no hash, selected followUp is most recent
                return this.followUps[0].id === followUp.id;
            }
            return false;
        },
    },
});
